import './Services.css';

function SrvHANESS() {
    const hanessItems = [
      { title: '검사 방식', value: '하네스 오픈/쇼트 검사' },
      { title: '지원 연결', value: '1:1 1:N' },
      { title: '최대 검사 라인 수', value: '40라인' },
      { title: '검사 모드', value: '자동 / 수동 / 반복검사' },
      { title: '결과 출력', value: '터치스크린 / QR코드 인쇄' },
      { title: '통신', value: '시리얼 (PC 또는 PLC 연동)' },
      { title: '공급전원', value: '100-240Vac 50/60Hz' }
    ];

    return (
      <div className="overview-container">
        <div className="section-title-box">하네스검사기 Haness Tester</div>
        <div className="services-header">
          <div className="services-image">
            <img src="/images/HanessTester.png" alt="HANESS TESTER외형" />
          </div>
          <div className="services-text">
            <p>
            <strong>전자제품에 사용되는 하네스의 품질을 확인하는 오픈/쇼트 검사장비입니다.</strong>
            </p>
            <p>  
            1:1 또는 1:N 연결을 지원하며, 최대 40라인까지 검사할 수 있습니다.  
            오픈 및 쇼트의 위치는 터치스크린을 통해 시각적으로 확인할 수 있습니다.  
            검사 도중 진동을 주어 불완전 조립을 탐지하는 반복검사 모드를 제공합니다.  
            검사 결과는 저장되며, 시리얼 통신을 통해 PC 또는 PLC로 전송할 수 있습니다.  
            또한 검사 결과에 따라 QR 코드 인쇄도 가능합니다.  
            자동모드에서는 하네스 연결 시 자동으로 검사하며, 수동모드에서는 버튼을 눌러 실행합니다.
            </p>
          </div>
        </div>

        <div className="overview-table">
            {hanessItems.map((item, index) => (
            <div key={index} className="overview-row">
                <div className="overview-title">{item.title}</div>
                <div className="overview-value">{item.value}</div>
            </div>
            ))}
        </div>
      </div>
    );
}

export default SrvHANESS;
